import GetComponent from "./GetComponent";

export default GetComponent;
